import {
  ApportionmentType,
  CardBrand,
  PaymentMethod,
  BrcodeType,
} from '@/app/shared/enums';
import {
  CreditModel,
  DebitModel,
  CobillingtimModel,
} from '@/app/shared/models';
import { Model } from '@/app/shared/models/model';
import { StatusChargeModel } from './payment-info-status-charge';

export class PaymentInfoModel extends Model {
  public Name!: string;
  public Document!: string;
  public DocumentType!: string;
  public PaymentMethod!: PaymentMethod;
  public ApportionmentType!: ApportionmentType;
  public ApportionmentValue!: number;
  public UpdatePaymentInstallmentContract!: boolean;
  public StatusChargePaymentMethod?: StatusChargeModel[];

  public Created?: Date;
  public Updated?: Date;

  public Credit?: CreditModel;
  public CardExpiration!: string;
  public CardHolder!: string;
  public CardKey!: string;
  public CardTruncatedNumber!: string;
  public CardBrand!: CardBrand;

  public Debit?: DebitModel;
  public BranchNumber!: string;
  public BranchDigit!: string;
  public AccountNumber!: string;
  public AccountDigit!: string;
  public AccountType!: string;
  public FinancialInstitutionCode!: string;

  public Phone?: string;
  public Email?: string;
  public RandomKey?: string;
  public BrcodeType?: BrcodeType;

  public InstallmentId?: string;
  public Type?: string;
  public Value!: number;

  public CobillingTIM?: CobillingtimModel;
  public ServiceId!: string;
  public SubscriptionId!: string;
  public MSISDN!: string;
  public Description!: string;
}
